import ClientsBase from '@/modules/clients/components/ClientsBase';
import ClientsDashboard from '@/modules/clients/views/Dashboard';
import ClientBase from '@/modules/clients/components/ClientBase';
import Overview from '@/modules/clients/views/clientDetail/Overview';
import Invoices from '@/modules/clients/views/clientDetail/Invoices';
import Projects from '@/modules/clients/views/clientDetail/Projects';
import Estimates from '@/modules/clients/views/clientDetail/Estimates';
import ClientActionTracker from '@/modules/clients/views/clientDetail/ClientActionTracker';
import store from '@/store';

const routes = [
  {
    path: '/clients/',
    component: ClientsBase,
    meta: { appKey: 'clients' },
    children: [
      {
        path: 'dashboard',
        name: 'ClientsDashboard',
        component: ClientsDashboard,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: '/details/:id/',
        component: ClientBase,
        meta: { appKey: 'clients' },
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        },
        children: [
          {
            path: 'overview',
            name: 'ClientOverview',
            component: Overview,
          },
          {
            path: 'invoices',
            name: 'ClientInvoices',
            component: Invoices,
          },
          {
            path: 'projects',
            name: 'ClientProjects',
            component: Projects,
          },
          {
            path: 'estimates',
            name: 'ClientEstimates',
            component: Estimates,
          },
          {
            path: 'action-tracker',
            name: 'ClientActionTracker',
            component: ClientActionTracker,
          }
        ]
      }
    ]
  }
]

export default routes
